// extracted by mini-css-extract-plugin
module.exports = {"content":"Guide_content__NDXtI"};